import React from "react";
import classNames from "classnames";

const DropDown = (props) => {
    const highlightInError = props.highlightError ? "idea-attribute--required" : null;

    return (
        <div inputId={props.inputId} className={classNames("pure-control-group", highlightInError)}>
            <label >{props.label}</label>
            <select className="idea-attribute__input"
                    onChange={(event) => props.onChange(event.currentTarget.value)}
                    value={props.selected}>
                <option value="cityNotSelected"/>
                { props.values.map(value => <option key={value} value={value}>{value}</option>) }
            </select>
        </div>
    );
};
DropDown.propsTypes = {
    highlightError: React.PropTypes.bool,
    inputId: React.PropTypes.string,
    label: React.PropTypes.string,
    onChange: React.PropTypes.func,
    selected: React.PropTypes.string,
    values: React.PropTypes.arrayOf(React.PropTypes.string)
};
DropDown.defaultProps = {
    selected: "cityNotSelected"
};

export default DropDown;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/DropDown.js
 **/